
import Button from 'components/_UI/Button';
import Text from 'components/_UI/Text'
import React, { useEffect, useState } from 'react'
import { BarChart, CheckCircle, Clock, DollarSign, PlusSquare, Tag } from 'react-feather';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors'
import FilterExpenses from './filter/FilterExpenses';
import ExpensesList from './ExpensesList';
import ExpensesForm from './ExpensesForm';
import ToastContainer from 'components/_UI/ToastsContainer';
import useToast from 'hooks/useToast';
import expensesApi from 'api/requests/expenses';
import { useEvent } from 'context/events/Event';
import NotResultDashBoard from 'components/commons/NotResultDashBoard';
import currency from 'helpers/currency';
import Loader from 'components/_UI/Loader';
import Modal from 'components/_UI/Modal';
import date from 'helpers/date';





export default function Expenses() {
    const [modalVisible, setModalVisible] = useState(false);
    const { toast, toasts } = useToast()
    const [refreshExpenses, setRefreshExpenses] = useState(false)
    const [totalExpenses, setTotalExpenses] = useState(null)
    const [expensesPaids, setExpensesPaid] = useState(null)
    const [pendingExpenses, setPendingExpenses] = useState(null)
    const [categoriesExpenses, setCategoriesExpenses] = useState(null)
    const {event} = useEvent()
    const [isLoading, setIsloading] = useState(false)
    const [isLoadingModal, setIsloadingModal] = useState(false)
    const [isEdit, setIsEdit] = useState(null)
    const [detail, setDetail] = useState(false)
    const [deleteExpense, setDeleteExpense] = useState(false)
    const [importances, setImportances] = useState([])
    const [categories, setCategories] = useState({})
    const [byCategory, setByCategory] = useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [expenseId, setExpenseId] = useState(null)

    useEffect(() => {
        getSummary(event?.slug)
       
    }, [refreshExpenses])
    

    function toggleModalAction() {
        setIsEdit(null)
        setModalVisible(true)
    }

    async function getSummary(slug) {
        setIsloading(true)
        try {
            const {data} = await expensesApi.getSummary(slug)
            
            setCategories(data?.categories)
            setTotalExpenses(data?.total_expenses)
            setExpensesPaid(data?.paid_expenses)
            setCategoriesExpenses(data?.total_categories)
            setPendingExpenses(data?.pending_expenses)
            setByCategory(data?.by_categories)
            setImportances(data?.importance_levels)
        } catch (error) {
            setIsloading(false)
        } finally {
            setIsloading(false)
        }
    }


    const categoryColors = {
        Alimentação: colors.successLight,
        Transporte: colors.primaryLight,
        Materiais: colors.warning,
        Decoração: colors.occasionalPink,
        Equipamentos: colors.gold,
        Marketing: colors.occasionalPurple,
        Outros: colors.coralGrey
}   ;

    
   

    const handleSuccess = ({ action }) => {
        toast.success(`Despesa ${action} com sucesso! `,
        { position: 'top-center' })
        setRefreshExpenses(!refreshExpenses)
    }

    function onDelete(id) {
      setDeleteExpense(true)
       setModalOpen(true)
       setExpenseId(id)
    }

    function onEdit(item) {
        setIsEdit(item)
        setDeleteExpense(false)
        setDetail(false)
        setModalVisible(true)
    }

    function onDetail(item) {
       setDetail(item)
       setDeleteExpense(false)
       setModalOpen(true)
    }

    function onCancel() {
        setDetail(false)
        setDeleteExpense(false)
        setIsEdit(false)
        setIsloading(false)
        setModalOpen(false)
    }

    function onToggleAction(item) {
        switch (item.type) {
            case 'delete':
                onDelete(item?.item?.id)
                break;
            case 'edit':
                onEdit(item?.item)
                break;
            case 'detail':
                onDetail(item?.item)
                break;
            default:
                break;
        }
    }

    async function onConfirm() {
        setIsloadingModal(true)
        try {
            await expensesApi.delete(expenseId)
            setModalOpen(true)
            setModalOpen(false)
            handleSuccess({ action: 'excluída' })
        } catch (error) {
            setIsloadingModal(false)
        } finally {
            setIsloadingModal(false)
        }    
    }
  return (
    <Column>
        <ToastContainer toasts={toasts} />
        <Container>
            <> 
                <Column>
                    <HeaderContent>
                        <Column>
                            <Text name='subtitle'  color={colors.nightDark}>
                                Controle de Despesas
                            </Text>

                            <Text>Gerencie todos os custos do seu evento</Text>
                        </Column>
                        <ButtonContainer>
                            <Button
                                variant='featured'
                                category='squired'
                                onClick={() => toggleModalAction()}
                            >
                               <PlusSquare color={colors.neutralLight} marginRight={'8px'} size={16} />
                               <Text
                                color={colors.neutralLight}
                                paddingBottom={0}
                                marginLeft={'6px'}
                            >
                                Nova Despesa
                            </Text>
                            </Button>
                        </ButtonContainer>
                    </HeaderContent>
                


                {
                    totalExpenses !== 0 ? (
                       
                         <>
                            {
                                isLoading ? (
                                    <Loader />
                                ) : (
                                    <>
                                        <ContainerResults>
                                            <ContentCard>
                                                <StyledTexts>
                                                        <Text>Total de Despesas</Text>
                                                        <Text name='subtitle' paddingBottom={0}>{currency.format(totalExpenses)}</Text>
                                                </StyledTexts>
                                                    
                                                    <ContentIcon>
                                                        <DollarSign size={20} color={colors.dangerDark}/>
                                                    </ContentIcon>
                                            </ContentCard>

                                            <ContentCard>
                                                <StyledTexts>
                                                    <Text>Despesas Pagas</Text>
                                                    <Text name='subtitle' paddingBottom={0} color={colors.successLight} >{currency.format(expensesPaids)}</Text>
                                            </StyledTexts>
                                            <ContentIcon>
                                                    <CheckCircle size={20} color={colors.successLight}/>
                                                </ContentIcon>
                                            </ContentCard>

                                            <ContentCard>
                                                <StyledTexts>
                                                    <Text>Pendentes</Text>
                                                    <Text name='subtitle' paddingBottom={0} color={colors.occasionalOrange}>{currency.format(pendingExpenses)}</Text>
                                            </StyledTexts>
                                            <ContentIcon>
                                                    <Clock size={20} color={colors.occasionalOrange}/>
                                                </ContentIcon>
                                            </ContentCard>

                                            {/* <ContentCard>
                                                <StyledTexts>
                                                    <Text>Categorias</Text>
                                                    <Text name='subtitle' paddingBottom={0} color={colors.primaryLight}>{categoriesExpenses}</Text>
                                            </StyledTexts>
                                            <ContentIcon>
                                                    <Tag size={20} color={colors.primaryLight}/>
                                                </ContentIcon>
                                            </ContentCard> */}
                                        </ContainerResults>

                                        <ContainerStatisticsExpenses>
                                            <Row>
                                                <BarChart size={20} color={colors.nightDark} />
                                                <Text name='subtitle' marginLeft={'10px'} color={colors.nightDark}>Despesas por Categoria</Text>
                                            </Row>
                                            <ContentStatistics>
                                                {byCategory?.map((item, index) => (
                                                    <StyledRow>
                                                        <Column>
                                                            <Row verticalCenter>
                                                                <StyledCategory  color={categoryColors[item.category_name] || '#ccc'}/>
                                                                <Text marginLeft={'10px'} paddingBottom={0} color={colors.nightDark}>{item.category_name}</Text>
                                                            </Row>
                                                        </Column>
                                                        <ContentValue>
                                                            <Text color={colors.nightDark} type='bold'>{currency.format(item.total)}</Text>
                                                            <Text>{item.percentage}</Text>
                        
                                                        </ContentValue>
                                                    </StyledRow>
                                                ))}
                                            </ContentStatistics>
                                        </ContainerStatisticsExpenses>

                                        {/* <ContentFilter>
                                            <FilterExpenses />
                                        </ContentFilter> */}
                                    </>
                                )
                            }

                            

                            <ContainerTable>
                                <ExpensesList categories={categories} refreshExpenses={refreshExpenses} toggleAction={onToggleAction}/>
                            </ContainerTable>
                        </>

                    ) : (

                         <ContentNotResult>
                            <NotResultDashBoard
                                text={
                                    <Text>Você ainda não possui despesas criada.</Text>
                                }
                                ilustration={'withdraw'}
                            />
                        </ContentNotResult>
                    )
                }
                    
                </Column>
            </>
            {
                modalVisible && (
                    <ExpensesForm 
                        visible={modalVisible}
                        onClose={() => setModalVisible(false)}
                        onSuccess={(action) => handleSuccess({ action })}
                        onError={() => toast.error('Ocorreu um erro inesperado', { position: 'top-center' })}
                        categories={categories}
                        isEdit={isEdit}
                        importances={importances}

                    />
                )
            }
        </Container>
       
        <Modal isOpen={modalOpen} onClose={() => onCancel()} size="small">
            {deleteExpense && (
                <>
                    <Text>Deseja realmente excluir esta despesa?</Text>

                    {isLoadingModal ? (
                        <Loader />
                    ) : (
                        <ContentConfirm>
                            <Button onClick={onCancel} variant="light" category="roundedBorded">
                                Cancelar
                            </Button>
                            <Button onClick={onConfirm}>Confirmar</Button>
                        </ContentConfirm>
                    )}
                </>
            )}

            {detail && (
                <ModalWrapper>
                    <Row>
                        <Text><b>Nome:</b> {detail?.name}</Text>
                    </Row>

                   
                    <Row>
                        <Text><b>Descrição:</b> {detail?.description ? detail?.description : 'Não informado'}</Text>
                    </Row>
                    
                    
                    <Row marginTop={'5px'}>
                        <Text><b>Categoria:</b> {detail?.category}</Text>
                    </Row>

                    <Row marginTop={'5px'}>
                        <Text><b>Status:</b>  {detail?.status == 1 
                                ? 'Pago' 
                                : detail?.status == 0 
                                ? 'Pendente' 
                                : detail?.status == 2 
                                    ? 'Orçamento' 
                                    : ''}
                        </Text>
                    </Row>

                    <Row marginTop={'5px'}>
                        <Text><b>Valor:</b> {currency?.format(parseFloat(detail?.amount))}</Text>
                    </Row>

                    
                    <Row marginTop={'5px'}>
                        <Text><b>Unidade:</b> {detail?.unit ? detail?.unit : 'Não informado'}</Text>
                    </Row>
                           
                    <Row marginTop={'5px'}>
                        <Text><b>Data:</b> {detail?.date ? date.format(detail?.date) : 'Não informado'}</Text>
                    </Row>

                    <Row marginTop={'5px'}>
                        <Text><b>Importância:</b> {detail?.importance_level ? detail?.importance_level : 'Não informado'}</Text>
                    </Row>

                    <Row marginTop={'5px'}>
                        <Text><b>Fornecedor:</b> {detail?.supplier ? detail?.supplier : 'Não informado'}</Text>
                    </Row>
                    
                </ModalWrapper>
            )}
        </Modal>

    </Column>
  )
}

const Container = styled(Column)`
    padding-bottom: 20px;
`;

const HeaderContent = styled(Column)`
    width: 100%;
    padding: 14px 0;
    
    & > button {
        margin-top: 20px;
    }
    
    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
`;


const ButtonContainer = styled.span`
  width: 100%;
  margin-top: 20px;

  @media screen and (min-width: ${breakpoints.md}) {
    width: 250px;
    margin-top: 0;
  }
`;

const ContainerResults = styled(Column)`
   width: 100%;
   margin-top: 10px;
   @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        gap: 5px;
        justify-content: space-between;
        align-items: center;
    }
`;

const ContentCard = styled(Row)`
   width: 100%;
   height: 100px;
   padding: 10px;
   background: ${colors.neutralLight};
   border-radius: 6px;
   border: 1px solid #e5e7eb;
   justify-content: space-evenly;
   align-items: center;
   margin-bottom: 10px;
    @media screen and (min-width: ${breakpoints.md}) {
       flex-direction: row;
        padding: 10px;
    }
`;


const ContentIcon = styled.div`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: ${colors.neutralDark};
`;


const StyledTexts = styled(Column)`
    width: 50%;
    justify-content: center;
`;

const ContainerStatisticsExpenses = styled.div`
   width: 100%;
   padding: 15px;
   background: ${colors.neutralLight};
   border-radius: 6px;
   border: 1px solid #e5e7eb;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;

`;

const ContentStatistics = styled(Column)`
    width: 100%;
    margin-top: 20px;
`

const StyledRow = styled(Row)`
 width: 100%;
 justify-content: space-around;
 margin-bottom: 10px;
`;

const ContentValue = styled(Column)`
    align-items: flex-end;

    & > p {
        font-size: 16px;
    }
`;

const StyledCategory = styled(Column)`
    width: 20px;
    height: 20px;
    border-radius: 50%;
   ${({ color }) =>
    color &&
    `
      background-color: ${color};
    `}
`

const ContentFilter = styled(Column)`
    width: 100%;
    margin-top: 10px;

`;

const ContainerTable = styled(Column)`
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 10px;
    background: ${colors.neutralLight};
    margin-top: 10px;
`;


const ContentNotResult = styled.div`
    & > div {
        flex-direction: column;
    }

    & > div > picture {
        width: 45%;
    }

    & > div > div {
        width: 100%;
    }
`;

const ContentConfirm = styled(Column)`
    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        margin-top: 10px;
        gap: 4px;
    }
`;

const ModalWrapper = styled(Column)`
    padding: 10px;

    & > p {
        text-transform: capitalize;
    }
`